export default "__VITE_ASSET__qZ3_umeC__"